/* HOOKSTER - keep the Shopify Inbox chat icon visible.

   THE BUG: the launcher renders as a solid black circle with nothing in it.
       button.activator      background  rgb(0, 0, 0)      (black)
       span.activator__icon  color       rgba(0, 0, 0, .7) (black, 70%)
   The icon is a STROKED svg (path fill:none, takes currentColor), so a black
   stroke on a black button is invisible.

   WHY JAVASCRIPT: the widget renders inside shadow roots, which stylesheets
   cannot cross. The roots are open, so a <style> can be appended into them.

   WHY IT HAS TO RECURSE, AND KEEP WATCHING (this is the part that bit us):
   a first version injected once into <shopify-chat>'s own shadow root and
   worked - until you opened the chat and closed it again, after which the
   circle went black once more. On interaction the widget re-renders itself
   into a NESTED shadow root: shopify-chat > #shadow > shopify-agent-runtime >
   #shadow > .activator. Our style was still sitting in the outer root, which
   cannot reach the inner one, so the restored launcher came back unstyled.

   So: walk every nested shadow root, inject into each, and attach a
   MutationObserver to each one so newly created roots get the same treatment
   when the widget rebuilds. Injecting a <style> is itself a childList change,
   hence the presence check plus the debounce - without both, this loops.

   THE CLEANER FIX is to set the launcher colours in the Shopify Inbox app
   (Sales channels > Inbox > Appearance). If that is ever done, delete this
   file and its <script> tag in sections/announcement.liquid.

   Colour matches the "GET 15% OFF" teaser, at Adam's request. */

(function () {
  'use strict';

  var HOST = 'shopify-chat';
  var STYLE_ID = 'hk-chat-icon';
  var ICON_COLOR = '#45E0FD';
  var MAX_DEPTH = 6;

  var CSS = '.activator__icon,.activator__icon svg,.activator__icon svg *' +
            '{color:' + ICON_COLOR + ' !important;stroke:' + ICON_COLOR + ' !important;}';

  var watched = (typeof WeakSet === 'function') ? new WeakSet() : null;
  var timer = null;

  function inject(root) {
    if (root.querySelector('#' + STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
  }

  function watch(root) {
    if (!watched || watched.has(root) || !window.MutationObserver) return;
    watched.add(root);
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  }

  function walk(root, depth) {
    if (!root || depth > MAX_DEPTH) return;
    inject(root);
    watch(root);

    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      if (els[i].shadowRoot) walk(els[i].shadowRoot, depth + 1);
    }
  }

  function run() {
    var host = document.querySelector(HOST);
    if (!host || !host.shadowRoot) return false;
    walk(host.shadowRoot, 0);
    return true;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 100);
  }

  function start() {
    if (run()) return;

    /* The app injects the widget well after page load. Poll only until it
       shows up - after that the observers take over. */
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (run() || tries > 60) clearInterval(poll);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
